import React, { ElementType, memo, ReactNode } from 'react';
import classNames from 'classnames';

import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography';

import styles from 'components/ProductGrid/ProductGrid.scss';

interface ProductGroupTitleProps {
  titleElement?: ElementType;
  title?: string | ReactNode;
  withBorder?: boolean;
}

const ProductGroupTitle = memo(
  ({ titleElement = 'h2', title, withBorder = true }: ProductGroupTitleProps) => {
    if (!title) {
      return null;
    }

    return (
      <header
        className={classNames(styles.productGroupTitle, {
          [styles.withBorder]: withBorder,
        })}
      >
        <Typography
          element={titleElement}
          styleAs="sectionHeading"
          data-testid="product-group-title"
          noMargins
        >
          {title}
        </Typography>
      </header>
    );
  },
);

ProductGroupTitle.displayName = 'ProductGroupTitle';

export default ProductGroupTitle;
